import client from 'api/client';

export function getAvailablePermissions(userId: number) {
    return client.get('/permissions', {
        params: { user_id: userId },
    });
}

export function getPermissions(clientId: number) {
    return client.get(`/users/${clientId}/permissions`);
}

export function deletePermissions(clientId: number, permissionName: string) {
    return client.delete(`/users/${clientId}/permissions`, {
        data: { permissionName },
    });
}

export function addUserPermission(clientId: number, permissionName: string) {
    return client.post(`/users/${clientId}/permissions`, {
        permissionName,
    });
}
